function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useCallback, useMemo } from 'react';
import { arrayOf, func, number } from 'prop-types';
import { styled } from '@mui/material/styles';
import { gridFilteredTopLevelRowCountSelector, gridPaginationModelSelector, useGridApiContext, useGridRootProps, useGridSelector } from '@mui/x-data-grid-pro';
import SovosPaginationFooter from '../sovos-pagination-footer/SovosPaginationFooter';
const PaginationFooter = styled(SovosPaginationFooter)({
  flex: '0 0 auto',
  marginTop: 'auto'
});
const SovosDataGridPagination = props => {
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const paginationModel = useGridSelector(apiRef, gridPaginationModelSelector);
  const visibleTopLevelRowCount = useGridSelector(apiRef, gridFilteredTopLevelRowCountSelector);
  const {
    page,
    pageSize
  } = paginationModel;
  const {
    pageSizeOptions,
    pagination,
    rowCount: rowCountProps
  } = rootProps;
  const rowCount = useMemo(() => {
    var _ref;
    return (_ref = rowCountProps !== null && rowCountProps !== void 0 ? rowCountProps : visibleTopLevelRowCount) !== null && _ref !== void 0 ? _ref : 0;
  }, [rowCountProps, visibleTopLevelRowCount]);
  const lastPage = useMemo(() => Math.floor(rowCount / (pageSize || 1)), [rowCount, pageSize]);
  const handlePageChange = useCallback((newPage, itemsPerPage) => {
    if (itemsPerPage !== pageSize) {
      apiRef.current.setPageSize(itemsPerPage);
    } else {
      apiRef.current.setPage(newPage - 1);
    }
  }, [apiRef, pageSize]);
  const isPageSizeIncludedInPageSizeOptions = pageSizeOption => {
    for (let i = 0; i < pageSizeOptions.length; i += 1) {
      const option = pageSizeOptions[i];
      if (typeof option === 'number') {
        if (option === pageSizeOption) {
          return true;
        }
      } else if (option.value === pageSizeOption) {
        return true;
      }
    }
    return false;
  };
  return /*#__PURE__*/React.createElement(PaginationFooter, _extends({
    currentPage: (page <= lastPage ? page : lastPage) + 1,
    displayItemsPerPageSelector: pagination,
    itemsPerPage: pagination ? pageSize : rowCount,
    itemsPerPageOptions: isPageSizeIncludedInPageSizeOptions(pageSize) ? pageSizeOptions : [],
    onPageChange: handlePageChange,
    totalItems: rowCount
  }, props));
};
SovosDataGridPagination.propTypes = {
  count: number,
  onPageChange: func,
  page: number,
  rowsPerPage: number,
  rowsPerPageOptions: arrayOf(number)
};
export default SovosDataGridPagination;